import React, { useEffect, useState } from 'react';
import './SiteDatabase.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { Space, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../Config';
import axios from 'axios';

const SiteDatabase = () => {
  const navigate = useNavigate();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [tasks, setTasks] = useState([]);

    useEffect(() => {
      let endpoint = API_URL + '/client'

      fetch(endpoint)
        .then((response) => response.json())
        .then((data) => setTasks(data))
        .catch((error) => console.error(error));
    }, []);

  const fetchTasks = (filterValue) => {
    let endpoint;

     if (filterValue) {
      endpoint = `${API_URL}/client/?filter=${filterValue}`;
    }
     else {
      endpoint = `${API_URL}/client`;
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setTasks(data))
      .catch((error) => console.error(error));
  };

  const getSiteDetails = (siteName) => {
    const filteredSite = tasks.filter(task => task.siteName === siteName);
    navigate('/SiteDetails', { state: { siteDetails: filteredSite[0] } });
  };

  const getSiteName = (siteName) => {
    navigate('/AgencyDatabase', { state: { siteName: siteName } });
  }

  const deleteSite = async (name) => {
    try {
      const response = await axios.delete(API_URL + `/client/${name}`);

      if (response.status === 204) {
        console.log('Site deleted successfully');
        fetchTasks();
      } else {
        console.error('Error deleting User');
      }
    } catch (error) {
      console.error(error);
    }
  };

  // =========== add site start ================================================
  const [formData, setFormData] = useState({
    clientName:  '',
    siteName:  '',
    siteAddress:  '',
    siteMobile: '',
    siteEmail: '',
    manager: '',
    work_type: '',
    reference_name: '',
    date_of_birth:  '',
    contractNo: '',
    registration_date:  '',
    interior_designer:  '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [clients, setClients] = useState([]);
  useEffect(() => {
    fetch(API_URL + '/client')
      .then(response => response.json())
      .then(data => setClients(data))
      .catch(error => console.error(error));
  }, []);

  let work_type_data;
  let manager_data;
  if(clients && clients.length > 0) {
     work_type_data = clients.map(user => user.work_type).filter((value, index, self) => self.indexOf(value) === index);
     manager_data = clients.map(user => user.manager).filter((value, index, self) => self.indexOf(value) === index);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch(API_URL + '/client', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Form data sent successfully:', data);
        closeForm();
        fetchTasks();
      })
      .catch((error) => {
        console.error('Error sending form data:', error);
      });
  };

  // =========== end ===========================================================


  const openForm = () => {
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setIsFormOpen(false);
  };

    const columns = [
      {
        title: 'Index',
        dataIndex: 'Index',
        key: 'Index',
        width: '10%',
      },
      {
        title: 'Site Name',
        dataIndex: 'SiteName',
        key: 'SiteName',
      },
      {
        title: 'View Agencies',
        dataIndex: 'ViewAgencies',
        key: 'ViewAgencies',
        render: (_, record ) => (
          <button className='view_agency_SiteDatabase' onClick={() => getSiteName(record.SiteName)}>
           View Agencies
          </button>
          // <Link to={{ pathname: '/AgencyDatabase', state: { siteName: record.SiteName } }}><p>&nbsp;View Agencies</p></Link>
        ),
      },
      {
        title: 'Action',
        key: 'action',
        width: '12%',
        render: (_, record) => (
          <Space size="middle">
            <button type="button" className="site_icon_action" onClick={() => getSiteDetails(record.SiteName)} aria-label={`Edit ${record.SiteName}`}>
            <img src="../assets/pencil.png" alt="" />
          </button>
          <button type="button" className="site_icon_action danger" onClick={() => deleteSite(record.SiteName)} aria-label={`Delete ${record.SiteName}`}>
            <img src="../assets/trash.png" alt="" />
          </button>
          </Space>
        ),
      },
    ];

    const dataa = tasks.length > 0 ? tasks.map((item, index) => ({
      key: index.toString(),
      Index: index + 1,
      SiteName: item.siteName || '',
    })) : [];


return (
      <div className="site_database_page">
        <SideMenuBar />

        <div className="content">
          <NewHeader />

          <main className="site_database_container">
            <section className="site_database_hero">
              <div>
                <span className="site_database_kicker">Client management</span>
                <h1 className="directory_Directory">Directory</h1>
                <p className="site_database_subtitle">
                  Manage project sites, client information and agency relationships from one place.
                </p>
              </div>
              <div className="directory_summary">
                <span>Total sites</span>
                <strong>{tasks.length}</strong>
                <small>Current database</small>
              </div>
            </section>

            <section className="directory_toolbar">
              <div className="directory_toolbar_intro">
                <span className="section_eyebrow">Site database</span>
                <strong>Project locations</strong>
              </div>
              <div className="directory_toolbar_actions">
                <label className="directory_search">
                  <img src="../assets/search.png" alt="" />
                  <input
                    placeholder="Search sites..."
                    aria-label="Search sites"
                    onChange={(e) => fetchTasks(e.target.value)}
                  />
                </label>
                <button type="button" onClick={openForm} className="add_site_btn_SiteDatabase">
                  <span>+</span> Add site
                </button>
              </div>
            </section>

            <section className="site_database_panel">
              <header className="site_database_panel_header">
                <div>
                  <span className="section_eyebrow">Directory</span>
                  <h2>All sites</h2>
                </div>
                <span className="site_count_badge">{tasks.length} sites</span>
              </header>
              <div className="table_SiteDatabase">
                <Table
                  className="modern_site_table"
                  columns={columns}
                  dataSource={dataa}
                  scroll={{ x: 720, y: 480 }}
                  pagination={false}
                />
              </div>
            </section>
          </main>
        </div>

        {isFormOpen && (
          <>
            <div className="overlay_SiteDatabase" onClick={closeForm}></div>
            <section className="popup-form_SiteDatabase" role="dialog" aria-modal="true" aria-label="Add Site">
              <header className="site_modal_header">
                <div>
                  <span className="section_eyebrow">New record</span>
                  <h2>Add Site</h2>
                  <p>Add the core client and project information to the directory.</p>
                </div>
                <button type="button" className="close_SiteDatabase" onClick={closeForm} aria-label="Close">×</button>
              </header>

              <form className="site_form" onSubmit={handleSubmit}>
                <div className="site_form_grid">
                  <div className="site_form_field"><label>Client Name</label><input placeholder="Enter client name" name="clientName" value={formData.clientName} onChange={handleInputChange} /></div>
                  <div className="site_form_field"><label>Site Name</label><input placeholder="Enter site name" name="siteName" value={formData.siteName} onChange={handleInputChange} /></div>
                  <div className="site_form_field"><label>Phone No.</label><input placeholder="Enter phone number" name="siteMobile" value={formData.siteMobile} onChange={handleInputChange} /></div>
                  <div className="site_form_field"><label>Email ID</label><input type="email" placeholder="Enter email address" name="siteEmail" value={formData.siteEmail} onChange={handleInputChange} /></div>
                  <div className="site_form_field"><label>Date of Birth</label><input type="date" name="date_of_birth" value={formData.date_of_birth} onChange={handleInputChange} /></div>
                  <div className="site_form_field"><label>Registration Date</label><input type="date" name="registration_date" value={formData.registration_date} onChange={handleInputChange} /></div>

                  <div className="site_form_field">
                    <label>Work Type</label>
                    <select name="work_type" value={formData.work_type} onChange={handleInputChange}>
                      <option value="" disabled>Select work type</option>
                      {(work_type_data || []).map((workType, index) => <option key={index} value={workType}>{workType}</option>)}
                    </select>
                  </div>

                  <div className="site_form_field">
                    <label>Manager</label>
                    <select name="manager" value={formData.manager} onChange={handleInputChange}>
                      <option value="" disabled>Select manager</option>
                      {(manager_data || []).map((manager, index) => <option key={index} value={manager}>{manager}</option>)}
                    </select>
                  </div>

                  <div className="site_form_field"><label>Contract No.</label><input placeholder="Enter contract number" name="contractNo" value={formData.contractNo} onChange={handleInputChange} /></div>
                  <div className="site_form_field"><label>Referral Name</label><input placeholder="Enter referral name" name="reference_name" value={formData.reference_name} onChange={handleInputChange} /></div>
                  <div className="site_form_field"><label>Interior Designer</label><input placeholder="Enter interior designer" name="interior_designer" value={formData.interior_designer} onChange={handleInputChange} /></div>
                  <div className="site_form_field site_form_field_full"><label>Address</label><textarea placeholder="Enter site address" name="siteAddress" value={formData.siteAddress} onChange={handleInputChange} /></div>
                </div>

                <footer className="site_form_footer">
                  <button type="button" className="site_form_cancel" onClick={closeForm}>Cancel</button>
                  <button type="submit" className="update_btn_input_SiteDatabase">Add site</button>
                </footer>
              </form>
            </section>
          </>
        )}
      </div>
    );
};

export default SiteDatabase;